<template>
  <div v-if="geolevelselected.level <= pageData.nivelMax && checkCountry" ref="maincontainerdiv" v-loading="loading" class="page-pdf page-pdf--horizontal mb-2">
    <div class="container-title-page-report">
      <div v-if="pageData.template === 'estandarTemplate'">
        {{ $t(pageData.report_name) }} {{ $t(geolevelselected.literalLevelname) }} {{ $t("of") }} {{ geolevelselected.name }} ({{ nivelGeoSup }})
      </div>
      <div v-if="pageData.template === 'benchmarksTemplate'">
        {{ $t(pageData.report_name) }} {{ $t("with_lower") }} {{ geolevelselected.name }} ({{ nivelGeoSup }})
      </div>
      <!-- <div class="container-header-page"> -->
      <a class="container-header-page" href="https://www.brainsre.com/" target="_blank" rel="noopener">
        <img v-if="logo" id="imglogo" :src="logo" alt="">
      </a>
      <!-- </div> -->
    </div>

    <!-- Formato de pagina para los reports basicos, los iniciales -->
    <div v-if="pageData.template === 'estandarTemplate'" class="container-data-page-report">
      <div class="data-page-report-col--1">
        <div class="container-map-title">{{ $t(pageData.map_name) }}</div>
        <div class="data-page-report--map" :class="{ 'ancho-mapa-82': fuenteMapa.length >= 175, 'ancho-mapa-79': fuenteMapa.length >= 255 }">
          <div v-if="geolevels.length > 0 && pageData.map_id !== ''" class="mrk_demomapscontainer" :class="{ 'preview-map--hidden': map_img !== '' }">
            <div class="mrk_map_container">
              <demomap
                ref="demoMap"
                :map-i-d="pageData.map_id"
                :legend-active="false"
                :geolevels="geolevels"
                :latitude="latitude"
                :longitude="longitude"
                legendtitle="Titulo leyenda"
                :zoom="reportZoomCustom"
                @mapLoaded="getFotoMapa()"
              />
            </div>
          </div>
          <img :src="map_img" :class="{ 'preview-map--visible': map_img !== '' }" alt="preview">
        </div>
        <div class="data-page-report--source">
          <!-- <span class="font-weight-600">{{ $t("maps.source") }}</span>: <span class="source--text">{{ fuenteMapa }} {{ fechaMapa }} ({{ $t(getLiteralSourceMap()) }})</span> -->
          <span class="font-weight-600">{{ $t("maps.source") }}</span>: <span class="source--text">{{ getDescriptionBD() }} {{ fuenteMapaBD.date_00 }} ({{ $t(getLiteralSourceMap()) }})</span>
        </div>
      </div>
      <div class="data-page-report-col--2">
        <div class="data-page-report--chart">
          <highcharts v-if="pageData.charts.length > 0 && pageData.charts[0].series.length" id="chart-1" :options="pageData.charts[0]" />
        </div>
        <div class="data-page-report--chart"><highcharts v-if="pageData.charts.length > 0 && pageData.charts[1].series.length" :options="pageData.charts[1]" /></div>
        <div class="data-page-report--source">
          <span class="font-weight-600">{{ $t("maps.source") }}</span>: <span class="source--text">{{ pageData.chart_source }} ({{ $t(geolevelselected.literalLevelname) }})</span>
        </div>
      </div>
    </div>

    <!-- Formato de pagina para el template de los bench -->
    <div v-if="pageData.template === 'benchmarksTemplate'" class="container-data-page-report container-data-page-report--full-height">
      <div class="date-page-report-bench">
        <div class="date-page-report-bench--chart"><highcharts v-if="pageData.charts.length > 0 && pageData.charts[0].series.length" id="chart-1" :options="pageData.charts[0]" /></div>
        <div class="date-page-report-bench--chart"><highcharts v-if="pageData.charts.length > 0 && pageData.charts[1].series.length" id="chart-2" :options="pageData.charts[1]" /></div>
        <div class="date-page-report-bench--chart"><highcharts v-if="pageData.charts.length > 0 && pageData.charts[2].series.length" id="chart-3" :options="pageData.charts[2]" /></div>
      </div>
    </div>

    <!-- {{ fuenteMapaBD }} -->
  </div>
</template>

<script>
import demomap from '@/components/exportvaluation/exportvalmap'
import logo from '@/assets/logo.png'

import Highcharts from 'highcharts'

import HighchartsMore from 'highcharts/highcharts-more'
import { mapState } from 'vuex'
HighchartsMore(Highcharts)

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.'
  },
  chart: {
    spacingLeft: 30,
    spacingRight: 30
  }
})

import { Chart } from 'highcharts-vue'

export default {
  name: 'PreviewReportPage',
  components: {
    highcharts: Chart,
    demomap
  },
  props: {
    pageData: {
      type: Object,
      default: () => {}
    },
    initPrint: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      map_img: '',
      logo: logo
    }
  },
  computed: {
    checkCountry() {
      if ((this.pageData.id === 'unemployment' || this.pageData.id === 'new_dev') && this.geolevels[0].id !== 1) {
        return false
      } else {
        return true
      }
    },
    ...mapState('maps', {
      mapsinit: (state) => state.availablemaps
    }),
    maps: function() {
      return this.mapsinit.item1
    },
    ...mapState('location', {
      geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels,
      latitude: (state) => state.position.latitude,
      longitude: (state) => state.position.longitude
    }),
    reportZoom: {
      get() {
        return this.$store.state['reports'].reportZoom
      }
    },
    /**
     * Se gestiona el zoom para mapas especificos que no tienen mas niveles
     */
    reportZoomCustom() {
      return this.reportZoom
    },
    mapSourceDetails: {
      get() {
        return this.$store.state['reports'].mapSourceDetails
      }
    },
    nivelGeoSup() {
      var nombre_final = this.geolevelselected.name
      switch (this.geolevelselected.level) {
        case 0:
          nombre_final = this.geolevels.filter((item) => {
            return item.level === 0
          })[0].name
          break
        case 1:
        case 2:
          nombre_final = this.geolevels.filter((item) => {
            return item.level === 1
          })[0].name
          break
        case 3:
          nombre_final = this.geolevels.filter((item) => {
            return item.level === 2
          })[0].name
          break
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
          nombre_final = this.geolevels.filter((item) => {
            return item.level === 3
          })[0].name
          break
        default:
          break
      }
      return nombre_final
    },
    fuenteMapaBD() {
      var result = []
      this.maps.forEach((item) => {
        if (item.child !== undefined) {
          try {
            item.child.forEach(item2 => {
              if (item2.child !== undefined) {
                item2.child.forEach(item3 => {
                  if (item3.id === this.pageData.map_id) {
                    result = item3
                  }
                })
              }
            })
          } catch (error) {
            console.log(error)
          }
        }
      })
      return result
    },
    fuenteMapa() {
      return this.mapSourceDetails.filter((item) => {
        return item.entidad === this.pageData.map_id
      })[0].fuente
    },
    fechaMapa() {
      return this.mapSourceDetails.filter((item) => {
        return item.entidad === this.pageData.map_id
      })[0].fecha
    },
    countryName() {
      if (this.geolevels.length === 0) return 'España'
      return this.geolevels.filter((item) => item.level === 0)[0].name
    }
  },
  watch: {
    initPrint(newOne, oldOne) {
      if (newOne === true && this.pageData.map_id !== null) {
        this.getFotoMapa()
      }
    }
  },

  methods: {
    getDescriptionBD() {
      return this.fuenteMapaBD.description_it
    },
    getLiteralSourceMap() {
      var geosup = []

      if (this.geolevelselected.level >= 4) {
        geosup = this.geolevels.filter(item => { return item.level === 4 })
      } else {
        geosup = this.geolevels.filter(item => { return item.level === (this.geolevelselected.level + 1) })
      }

      // Se comprueba que no haya ningun fallo en obtener el nivel superior, en caso contrario se establece el geolevelselected
      if (geosup !== null && geosup !== undefined && geosup.length > 0) {
        return geosup[0].literalLevelname
      } else {
        return this.geolevelselected.literalLevelname
      }
    },
    getFotoMapa() {
      this.$refs.demoMap.currentMapView.takeScreenshot().then(async(screenshot) => {
        this.map_img = screenshot.dataUrl
      })
    }
  }
}
</script>

<style lang="scss">
.mrk_demomapscontainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 15px;

  .mrk_map_container {
    height: 560px;
    overflow: hidden;
  }
  .mrk_maptitle {
    margin-bottom: 10px;
  }
  .mrk_maptitle:nth-child(n + 2) {
    margin-top: 25px;
  }
  .boldertxt {
    font-weight: bold;
  }
}

.page-pdf--horizontal {
  width: 1366px;
  height: 764px;
  border: 1px solid black;
  padding: 20px;
  font-family: "Montserrat-Regular",sans-serif;
  background-color: white;

  .container-title-page-report {
    font-size: 30px;
    font-family: "Montserrat-ExtraBold",sans-serif;
    margin: 0 300px 15px 15px;
    padding-bottom: 5px;
    border-bottom: 5px solid #1e3cff;
    position: relative;
    display: flex;
    align-items: center;

    .container-header-page {
      position: absolute;
      right: -277px;
      padding-top: 2px;

      img {
        max-height: 45px;
      }
    }
  }

  .container-data-page-report {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;

    &--full-height {
      height: 655px;
    }

    // Estilos para el template basico
    .data-page-report-col--1,
    .data-page-report-col--2 {
      width: 50%;

      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      flex-direction: column;

      .data-page-report--source {
        margin-top: 15px;
        padding-left: 15px;

        font-size: 11px;

        .source--text {
          color: grey;
        }
      }

      .container-map-title {
        height: 30px;
        font-size: 17px;
        width: 100%;
        display: flex;
        align-items: center;
        background-color: white;
        justify-content: center;
      }
    }

    .data-page-report-col--1 {
      .data-page-report--map {
        width: 100%;
        height: 85%;

        .preview-map--hidden {
          display: none;
        }

        .preview-map--visible {
          padding-left: 15px;
          margin-bottom: 25px;
        }
      }
    }

    .data-page-report-col--2 {
      .data-page-report--chart {
        height: 45%;
        width: 100%;
        font-family: "Montserrat-Regular",sans-serif !important;

        div .highcharts-container {
          padding-top: 0;
          padding-bottom: 0;
          font-family: "Montserrat-Regular",sans-serif !important;
        }
      }

      .data-page-report--source {
        text-align: right;
        padding-right: 25px;
      }
    }

    // Estilos para el template de bench
    .date-page-report-bench {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr;

      &--chart {
        width: 100%;
        height: 100%;
      }
    }

  }
}

.ancho-mapa-80 {
  height: 82% !important;
}

.ancho-mapa-79 {
  height: 79% !important;
}

.highcharts-title {
  text-decoration: none;
  font-family: "Montserrat-Regular",sans-serif !important;
}

.html2canvas-container {
  font-family: "Montserrat-Regular",sans-serif !important;
}
</style>
